/**
 * Announcement how-often-to-show (popup / toast / product splash).
 * once = dismiss for good; daily = once per calendar day; always = every visit
 * (same browser session still stays closed after dismiss).
 */

export const ANNOUNCEMENT_DISPLAY_FREQUENCIES = ['once', 'daily', 'always'];

export const ANNOUNCEMENT_DISPLAY_FREQUENCY_OPTIONS = [
    { value: 'once', label: 'Show once (dismiss permanently)' },
    { value: 'daily', label: 'Once per day' },
    { value: 'always', label: 'Every visit (until expired)' },
];

export function normalizeAnnouncementDisplayFrequency(raw) {
    const value = String(raw || '')
        .trim()
        .toLowerCase();
    if (value === 'always' || value === 'daily' || value === 'once') return value;
    if (value === 'session' || value === 'every' || value === 'multi') return 'always';
    return 'once';
}

export function announcementFrequencyLabel(raw) {
    const freq = normalizeAnnouncementDisplayFrequency(raw);
    if (freq === 'always') return 'Every visit';
    if (freq === 'daily') return 'Once a day';
    return 'Show once';
}

export function shouldPersistAnnouncementDismiss(raw) {
    return normalizeAnnouncementDisplayFrequency(raw) === 'once';
}

export function isoDayFromUnknown(value) {
    if (!value) return '';
    if (typeof value === 'string') {
        const day = value.slice(0, 10);
        return /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : '';
    }
    if (typeof value === 'object') {
        if (typeof value.toDate === 'function') {
            try {
                return isoDayFromUnknown(value.toDate().toISOString());
            } catch {
                return '';
            }
        }
        if (typeof value.seconds === 'number') {
            return isoDayFromUnknown(new Date(value.seconds * 1000).toISOString());
        }
        return isoDayFromUnknown(value.seenAt);
    }
    return '';
}

/** True when a stored seen stamp should hide the announcement for this frequency. */
export function isSeenForDisplayFrequency(seenEntry, freq, isoDate) {
    const normalized = normalizeAnnouncementDisplayFrequency(freq);
    if (normalized === 'always') return false;
    if (!seenEntry) return false;
    if (normalized === 'daily') {
        const today = String(isoDate || '').trim().slice(0, 10);
        if (!today) return Boolean(seenEntry);
        const seenDay = isoDayFromUnknown(seenEntry);
        if (seenDay) return seenDay === today;
        return seenEntry === true;
    }
    return true;
}
